/**
 * What the CRF Builder's form-code badge editor saves when it closes (Enter or
 * clicking away). Returns the code to save, or null to save nothing.
 *
 * Nothing is saved unless the user changed the box. The editor opens showing
 * the badge value - for a form with no code in the page's copy, the code
 * worked out from its name. Until 2026-09-11 the close compared the box with
 * the page's stored code instead, so opening and clicking away saved the
 * name-derived code, over any stored code the page did not know about.
 *
 * Pure so it can be tested under functions' vitest (`npm run test:web`).
 */
export interface FormCodeEditClose {
  /** The code in the page's copy of the form, if any. */
  stored?: string;
  /** What the box showed when the editor opened (the badge value). */
  openedWith: string;
  /** What the box holds now. */
  typed: string;
}

export function formCodeToSaveOnClose({ stored, openedWith, typed }: FormCodeEditClose): string | null {
  const next = typed.trim().toUpperCase();
  if (next === openedWith.trim().toUpperCase()) return null;
  // An emptied box resets a code the page holds. With none to reset there is
  // nothing to save.
  if (!next) return (stored || '').trim() ? '' : null;
  return next;
}
